var _rect, _g, _rect2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankFindingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 24,
    viewBox: "0 0 37 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_129_29653",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_129_29653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.74988 17V9.00001H7.74988V17H6.74988ZM11.7499 17V9.00001H12.7499V17H11.7499ZM3.78833 20V19H20.7114V20H3.78833ZM16.7499 17V9.00001H17.7499V17H16.7499ZM3.78833 7.00001V6.15386L12.2499 2.11539L20.7114 6.15386V7.00001H3.78833ZM6.43066 6.00001H18.0691L12.2499 3.25001L6.43066 6.00001Z",
    fill: "#A3A3A3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_129_29653",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 2,
    width: 21,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 2,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_129_29653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3149 16.359C26.4853 16.359 26.6303 16.2989 26.7499 16.1786C26.8696 16.0583 26.9294 15.913 26.9294 15.7427C26.9294 15.5724 26.8693 15.4274 26.749 15.3077C26.6288 15.188 26.4835 15.1282 26.3131 15.1282C26.1428 15.1282 25.9978 15.1884 25.8781 15.3086C25.7585 15.4289 25.6986 15.5742 25.6986 15.7445C25.6986 15.9148 25.7588 16.0598 25.879 16.1795C25.9993 16.2992 26.1446 16.359 26.3149 16.359ZM25.8845 13.6202H26.6682C26.6896 13.2025 26.7507 12.9047 26.8517 12.7268C26.9526 12.5489 27.1126 12.3467 27.3316 12.1202C27.8284 11.6373 28.1572 11.2452 28.318 10.9439C28.4788 10.6426 28.5592 10.3263 28.5592 9.99478C28.5592 9.35189 28.3528 8.80422 27.9399 8.35176C27.5269 7.8993 26.9914 7.67307 26.3333 7.67307C25.8172 7.67307 25.3362 7.81517 24.8901 8.09936C24.4441 8.38356 24.1169 8.76497 23.9086 9.24359L24.6538 9.58174C24.8429 9.13943 25.0755 8.84002 25.3517 8.68351C25.6279 8.52698 25.9305 8.44872 26.2595 8.44872C26.7446 8.44872 27.1255 8.58654 27.4022 8.8622C27.6789 9.13784 27.8172 9.48826 27.8172 9.91347C27.8172 10.2436 27.7149 10.5256 27.5103 10.7596C27.3057 10.9936 27.0715 11.2393 26.8076 11.4968C26.4497 11.8451 26.2064 12.1776 26.0776 12.4944C25.9489 12.8112 25.8845 13.1864 25.8845 13.6202ZM26.2527 19.1667C25.2711 19.1667 24.3447 18.9803 23.4733 18.6075C22.602 18.2348 21.839 17.7214 21.1845 17.0675C20.5299 16.4136 20.0161 15.6514 19.643 14.7809C19.2698 13.9104 19.0833 12.9844 19.0833 12.0028C19.0833 11.0073 19.2696 10.0774 19.6424 9.21301C20.0152 8.34861 20.5285 7.58913 21.1824 6.93457C21.8364 6.28003 22.5986 5.76619 23.469 5.39305C24.3395 5.01991 25.2656 4.83334 26.2471 4.83334C27.2426 4.83334 28.1725 5.01973 29.0369 5.39249C29.9013 5.76527 30.6608 6.27861 31.3154 6.93253C31.9699 7.58645 32.4837 8.34518 32.8569 9.20872C33.23 10.0723 33.4166 11.0018 33.4166 11.9972C33.4166 12.9788 33.2302 13.9052 32.8574 14.7766C32.4847 15.6479 31.9713 16.4109 31.3174 17.0654C30.6635 17.72 29.9048 18.2338 29.0412 18.607C28.1777 18.9801 27.2482 19.1667 26.2527 19.1667Z",
    fill: "#F59E0B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankFindingIcon);
export default __webpack_public_path__ + "static/media/bank-finding-icon.8855dc7d54819528d479f9b4868a95af.svg";
export { ForwardRef as ReactComponent };